import { RootState } from "../types";

export const wsFeeds = (state: RootState) => state.orderHistoryDetails.orderDetails;